var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgJe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.334h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.334h512v341.337H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M301.255 255.997L512 115.499v-30.17h-45.255L256 225.826 45.255 85.329H0v30.17l210.745 140.498L0 396.494v30.169h45.255L256 286.167l210.745 140.496H512v-30.169z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M233.739 166.953L256 172.518l22.261-5.565v-18.922l-8.904 4.453L256 139.127l-13.357 13.357-8.904-4.453z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M233.739 166.953v13.914c0 17.04 22.261 22.261 22.261 22.261s22.261-5.221 22.261-22.261v-13.914h-44.522z",
  fill: "#d80027"
})));

export default SvgJe;